var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Recurso17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.93 23.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "administracion"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.23,14.73c-.17,0-.31-.14-.31-.31V6.03c0-2.99-2.43-5.42-5.42-5.42s-5.42,2.43-5.42,5.42v8.39c0,.17-.14.31-.31.31s-.31-.14-.31-.31V6.03C4.47,2.71,7.18,0,10.5,0s6.03,2.71,6.03,6.03v8.39c0,.17-.14.31-.31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.43,13.71c-3.7,0-4.06-6.6-4.07-6.88,0-.17.12-.31.29-.32.18-.03.31.12.32.29,0,.06.34,6.3,3.46,6.3,2.68,0,3.42-4.23,3.58-5.49-5.57.23-6.46-3.52-6.47-3.56-.04-.17.07-.33.24-.36.16-.03.33.07.36.23h0c.03.14.82,3.43,6.19,3.05.09,0,.18.03.24.09.06.06.09.15.09.24-.02.26-.53,6.4-4.23,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.31,23.25s-.02,0-.02,0c-.17-.01-.29-.16-.28-.33l.47-6.12s.38-2.39,2.95-2.56h.17c2.46-.17,3.87-.34,4.26-1.89.04-.16.21-.26.37-.22.16.04.26.21.22.37-.51,2.05-2.51,2.19-4.81,2.34h-.17c-2.07.15-2.37,1.95-2.39,2.03l-.47,6.1c-.01.16-.15.28-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.62,23.25c-.16,0-.29-.12-.3-.28l-.47-6.12c0-.05-.31-1.86-2.38-1.99h-.17c-2.31-.16-4.3-.3-4.81-2.35-.04-.16.06-.33.22-.37.16-.04.33.06.37.22.39,1.55,1.8,1.71,4.26,1.88h.17c2.57.18,2.95,2.52,2.95,2.55l.47,6.14c.01.17-.11.32-.28.33,0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.66,19.77h-2.89c-.17,0-.31-.14-.31-.31s.14-.31.31-.31h2.89c.17,0,.31.14.31.31s-.14.31-.31.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Recurso17);
export default __webpack_public_path__ + "static/media/1Recurso17.50825d4bb38fd19515a84e482e746121.svg";
export { ForwardRef as ReactComponent };